"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        type: 'select',
        input: true,
        weight: 5,
        tooltip: 'The source to use for the select data.',
        key: 'dataSrc',
        defaultValue: 'aripost',
        label: 'Data Source Type',
        dataSrc: 'values',
        data: {
            values: [
                { label: 'Custom', value: 'custom' },
                //simple
                { label: 'From Ari', value: 'aripost' },
            ],
        },
    },
    {
        type: 'textarea',
        key: 'formulaDataSource',
        label: 'Formula Default Data Source',
        tooltip: 'Formula Data Source',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 6,
        placeholder: 'Data source in json format',
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'custom'] },
        },
    },
    {
        type: 'textarea',
        key: 'defaultRule',
        label: 'Default Rule',
        tooltip: 'Default Rule',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 6,
        placeholder: 'Data rule in json format',
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'custom'] },
        },
    },
    //simple
    {
        type: 'textfield',
        inputType: 'url',
        key: 'ariaction',
        input: true,
        weight: 5,
        label: 'Ari Action',
        tooltip: 'The API path that not included domain and API version.',
        placeholder: 'bo/bank/list',
        defaultValue: 'bo/formula/datasource',
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'aripost'] },
        },
    },
    //simple
    {
        type: 'datagrid',
        key: 'aribody',
        input: true,
        weight: 6,
        label: 'Request message body',
        addAnother: 'Add Node',
        tooltip: 'JSON body message structure',
        components: [
            {
                key: 'path',
                label: 'Path',
                input: true,
                type: 'textfield',
            },
            {
                type: 'select',
                key: 'type',
                label: 'Type',
                input: true,
                dataSrc: 'values',
                data: {
                    values: [
                        { label: 'Value', value: 'value' },
                        { label: 'Data', value: 'data' },
                        { label: 'Script', value: 'script' },
                    ],
                },
                defaultValue: 'data'
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                //rows: 3,
                //editor: 'ace',
                as: 'javascript',
                type: 'textarea',
                attributes: {
                    style: 'height:calc(1.5em + .75rem + 2px)',
                },
                placeholder: '',
            }
        ],
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'aripost'] },
        },
    },
    {
        type: 'textfield',
        input: true,
        label: 'Data Source Path',
        key: 'dataSourcePath',
        weight: 7,
        defaultValue: 'dataSource',
        description: 'The object path to the iterable items.',
        tooltip: 'The property within the source data, where iterable items reside. For example: results.items or results[0].items',
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'aripost'] },
        },
    },
    {
        type: 'textfield',
        input: true,
        label: 'Default Rule Path',
        key: 'defaultRulePath',
        weight: 8,
        defaultValue: 'rule',
        description: 'The object path to the iterable items.',
        tooltip: 'The property within the source data, where iterable items reside. For example: results.items or results[0].items',
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'aripost'] },
        },
    },
];
